module.exports = __webpack_public_path__ + "img/img10.d26c269b.png";